/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {shouldScroll} from "../../../actions/my-puratos/alerts.action";

class ScrollToTop extends Component {
    componentDidUpdate(prevProps) {
        if ((this.props.location && prevProps.location && this.props.location.pathname !== prevProps.location.pathname) ||
            (this.props.shouldScroll !== prevProps.shouldScroll && this.props.shouldScroll)) {
            window.scrollTo(0, 0);
            this.props.setShouldScroll(false);

        }
    }

    render() {
        return this.props.children;
    }
}

const mapStateToProps = (state) => ({
    shouldScroll: state.myPuratos_alerts.shouldScroll,
});
const mapDispatchToProps = {
    setShouldScroll: shouldScroll
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ScrollToTop));

